
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Menieres(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Meniere's disease"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>Ménière's disease is a disorder of the inner ear that causes severe
                                    dizziness (vertigo), ringing in the ears (tinnitus), hearing loss, and a
                                    feeling of fullness or congestion in the ear. Ménière's disease usually
                                    affects only one ear.</p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Meniere's-disease/1.png")} alt="Meniere's-disease" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Symptom</b></p>
                                <p><b>Recurring episodes of vertigo: </b>
                                    You have a spinning sensation that starts and stops spontaneously.
                                    Episodes of vertigo occur without warning and usually last 20 minutes to several hours, but not more
                                    than 24 hours. Severe vertigo can cause nausea.
                                </p>
                                <p><b>Hearing loss: </b>
                                    Hearing loss in Meniere's disease may come and go, particularly early on. Eventually,
                                    most people have some permanent hearing loss.</p>
                                <p><b>Ringing in the ear (tinnitus): </b>
                                    Tinnitus is the perception of a ringing, buzzing, roaring, whistling or
                                    hissing sound in your ear.</p>
                                <p><b>Feeling of fullness in the ear: </b>People with Meniere's disease often feel pressure in an affected ear
                                    (aural fullness).</p>
                                <a className="links" href="https://en.wikipedia.org/wiki/M%C3%A9ni%C3%A8re%27s_disease">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Menieres;